import { PropTypes } from "base/react-libs";
import SelectedTaskDetails from "./selected-task/selected-task-details";
import JourneysTaskTableRow from "./task-row/journeys-task-table-row";
import JourneysTaskTableHeader from "./journeys-task-table-header";
import EmptyStateMessage from "components/lists/empty-state-message";

const JourneysTaskTable = ({
  journey = {},
  selectedTask,
  setSelectedTask,
  optionalStateManagementFunction = () => {},
}) => {
  const { steps: journeySteps } = journey;

  const generateEmptyStateMessage = () => {
    if (Object.keys(journey).length && !(journeySteps && journeySteps.length)) {
      return "This Cadence does not have any steps yet.";
    } else return "Please select a Cadence.";
  };

  return (
    <>
      {Object.keys(journey).length && journeySteps && journeySteps.length ? (
        <div className="journeys-task-table--container">
          <div className="journeys-task-table--body">
            <div className="journeys-task-table--body--left">
              <JourneysTaskTableHeader journey={journey} />
              {journeySteps &&
                journeySteps.map((step, i) => (
                  <JourneysTaskTableRow
                    key={`task-${step.id}`}
                    step={step}
                    journey={journey}
                    isFinalStep={!!(i === journeySteps.length - 1)} // these are sorted by step_number in gql, so the last one is the final step
                    setSelectedTask={setSelectedTask}
                    optionalStateManagementFunction={optionalStateManagementFunction}
                  />
                ))}
            </div>
            <div className="journeys-task-table--body--right">
              <SelectedTaskDetails journey={journey} selectedTask={selectedTask} />
            </div>
          </div>
        </div>
      ) : (
        <EmptyStateMessage text={generateEmptyStateMessage()} />
      )}
    </>
  );
};

JourneysTaskTable.propTypes = {
  journey: PropTypes.object.isRequired,
  selectedTask: PropTypes.object,
  setSelectedTask: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
};

export default JourneysTaskTable;
